export default __webpack_public_path__ + "static/media/quentinT.d74ad678.png";